import React, { useState, useEffect, useRef } from 'react';
import menuService from './MenuService';

const FloatingFooter = () => {
    const [message, setMessage] = useState('');
    const [visible, setVisible] = useState(true);
    const lastScrollY = useRef(window.scrollY);

    useEffect(() => {
        const service = new menuService();
        service.getGeneralMessage().then(msg => setMessage(msg));
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            if (currentScrollY > lastScrollY.current) {
                // scrolling down
                setVisible(false);
            } else {
                // scrolling up
                setVisible(true);
            }
            lastScrollY.current = currentScrollY;
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    if (!message) return null;

    return (
        <div style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            background: '#222',
            color: '#fff',
            padding: '12px 16px',
            textAlign: 'center',
            fontSize: '0.95rem',
            zIndex: 1000,
            transform: visible ? 'translateY(0)' : 'translateY(100%)',
            transition: 'transform 0.3s ease',
            boxShadow: '0 -2px 8px rgba(0,0,0,0.3)',
        }}>
            {message}
        </div>
    );
};

export default FloatingFooter;
